import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ProjectSettingsDefaultReviewersLoadable = Loadable({
  loading: LoadingPage,
  loader: () =>
    import(
      /* webpackChunkName: "project-settings-default-reviewers" */ './default-reviewers'
    ),
});
